import React, { useEffect } from 'react';
import { useApp } from '../../app/AppContext';
import { BackButtonHandler } from '../../utils/BackButtonHandler';
import {Board} from "../../models/types";

type Props = { board: Board };
const BackButtonManager: React.FC<Props> = (props:Props) => {
	const { app } = useApp();
	const isMobile = document.body.classList.contains('is-mobile');

	useEffect(() => {
		if (!isMobile) {
			// Не запускаем на десктопе
			return;
		}

		// Регистрируем глобальный обработчик кнопки "назад"
		// Обратите внимание, что этот обработчик будет вызван только если
		// ни один из других обработчиков не вернул true
		const unregisterBackButton = BackButtonHandler.getInstance().register(() => {
			// Проверяем, находимся ли мы на главном экране
			// В нашем случае - если нет активного редактирования и пользователь на главной доске
			const currentBoard = props.board;
			const editState = app.getEditState();
			const taskEditController = app.getTaskEditController();

			// Если доска в режиме редактирования или есть активный редактор задач,
			// то обработчик в других компонентах уже сработает
			if (currentBoard.isEditing || taskEditController.state.isEditing) {
				return false; // Позволяем другим обработчикам сработать
			}

			// Мы на главном экране - возвращаем false, чтобы позволить
			// глобальному обработчику в BackButtonHandler выполнить логику двойного нажатия
			return false;
		});

		// При размонтировании компонента отписываемся
		return () => {
			unregisterBackButton();
		};
	}, [isMobile, app]);

	return null; // Этот компонент не рендерит ничего
};

export default BackButtonManager;